module.exports = __webpack_public_path__ + "img/partner-4.d5bc352c.png";